import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

function target(role) {
  if (role === "admin" || role === "superadmin") return "/administration";
  if (role === "center") return "/espace-centre";
  return "/espace-client";
}

export default function Login() {
  const nav = useNavigate();
  const { login, user } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user && user.role) nav(target(user.role), { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(identifier, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Connexion réussie");
      nav(target(r.user.role));
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] hero-bg grid place-items-center py-14 px-6">
      <div className="w-full max-w-md bg-white p-8 md:p-10 rounded-2xl border border-slate-100 card-lux">
        <div className="text-gold uppercase tracking-widest text-xs font-semibold">Connexion</div>
        <h1 className="font-heading text-3xl text-primary-blue mt-2">Bon retour !</h1>
        <form onSubmit={submit} className="mt-6 space-y-5">
          <div>
            <Label htmlFor="identifier">E-mail ou numéro de téléphone</Label>
            <Input
              id="identifier"
              type="text"
              autoComplete="username"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              className="mt-1 h-11"
              required
              data-testid="login-identifier"
              placeholder="email@exemple.fr ou 06 12 34 56 78"
            />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 h-11" required data-testid="login-password" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-primary-blue text-white h-12 text-base" data-testid="login-submit">
            <LogIn size={18} className="mr-2" /> {busy ? "Connexion…" : "Se connecter"}
          </Button>
        </form>
        <div className="mt-6 text-sm text-slate-600">
          Pas encore de compte ? <Link to="/inscription" className="text-primary-blue underline" data-testid="login-to-register">Créer un compte client</Link>
        </div>
      </div>
    </div>
  );
}
